import { action } from 'easy-peasy';
import { IActionResetTeamMemberDateValidation } from '../types';

const resetTeamMemberDateValidation: IActionResetTeamMemberDateValidation = action(state => {
  state.teamMemberDateValidation = null;
});

export default resetTeamMemberDateValidation;
